// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/PPFragment-TextRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/PPFragment-GlareRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/PPFragment-GlareExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/PPFragment-GlareLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/PPFragment-SansRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/PPFragment-SansExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/PPFragment-SansLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/PPFragment-SerifRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/PPFragment-SerifExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/PPFragment-SerifLight.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Static font imports start*/
@font-face {
  font-family: "PP Fragment";
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Glare";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Glare";
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Glare";
  font-weight: lighter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Sans";
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Sans";
  font-weight: lighter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Serif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Serif";
  font-weight: bold;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("opentype");
}

@font-face {
  font-family: "PP Fragment-Serif";
  font-weight: 0 300;
  font-style: lighter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("opentype");
}

/* Static font imports end*/

html {
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  box-sizing: border-box;
}

/* Make autofill in input of background white */
/* input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: black;
    color: black;
} */

/* .top-container-lg input:-webkit-autofill,
.top-container-lg input:-webkit-autofill:hover,
.top-container-lg input:-webkit-autofill:focus,
.top-container-lg input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: black;
    color: black;
} */

.padding_all {
  padding: 20px 50px;
}

.max-width1400 {
  max-width: 1800px !important;
  margin-left: auto;
  margin-right: auto;
}

.ReactCollapse--collapse {
  transition: height 200ms;
}

img {
  max-width: 100%;
}

.mySwiper {
  width: 100%;
}
.mySwiper-investors {
  width: 100%;
  height: 720px;
  display: flex;
}

.swiper-slide {
  justify-content: center;
  display: flex;
}
.swiper-slide-investors {
  width: 400px;
  border-radius: 16px;
  height: fit-content;
}

.swiper-pagination-bullet-active {
  background: #fff !important;
}

/* Slick slider css start */

.slick-next:before {
  /* important used to overide the slick slider default css */
  font-size: 28px !important;
  /* color: #58f2f0 !important; */
}

.slick-prev:before {
  /* important used to overide the slick slider default css */
  font-size: 28px !important;
  /* color: #58f2f0 !important; */
}

/* Slick slider css end */

.inputRounded .MuiOutlinedInput-root {
  border-radius: 30px;
  height: 48px;
  padding-right: 6px !important;
  /* border: 2px solid #58f2ef8f !important; */
}

.inputRounded {
  height: 48px;
  margin-bottom: 2vh;
  border-radius: 30px;
  margin-top: 10px;
  width: 100%;
}

/* .top-container-lg .inputRounded {
    border: 1px solid #58f2ef8f !important;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border: 1px solid #6976b4;
} */

.MuiTabs-indicator {
  background-color: #046149 !important;
}

.layout_body {
  min-height: 100vh;
  padding-top: 70px;
  overflow: hidden;
}

.selected-link {
  /* color: #58f2f0 !important;
    border-bottom: 2px solid #58f2f0; */
  padding-bottom: 11px !important;
}

.hiw-slider .slick-initialized .slick-slide {
  width: auto !important;
}

.lazy-load-image-background.blur.lazy-load-image-loaded {
  height: 100%;
}

.MuiMenuItem-root {
  min-height: 20px !important;
}

.small_screen {
  display: none;
}

.header_variant {
  /* background: #2D355A; */
  position: sticky;
}

.market_header {
  /* background: transparent; */
  position: sticky;
}

.header_padding {
  padding-top: 80px;
}

.hiw-slider .slick-list {
  padding: 0 0 0 3% !important;
}

.show-mobile {
  display: block !important;
}

/* Responsivness css start */

@media screen and (min-device-width: 1200px) and (max-device-width: 1400px) {
  .inputRounded {
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .inputRounded {
    width: 100%;
  }
}

@media screen and (max-width: 570px) {
  .padding_all {
    padding: 0px 20px;
  }
  .no-padding-left {
    padding-left: 0 !important;
  }
  .small_screen {
    display: block !important;
  }
  .large_screen {
    display: none;
  }
  .inputRounded .MuiOutlinedInput-root {
    width: 100%;
  }
}

@media screen and (max-width: 426px) {
  .text-wrap-div-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: no-wrap;
  }
  .text-wrap-div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: no-wrap;
  }
  .large_screen {
    display: none;
  }
  .small_screen {
    display: block !important;
  }
  .testimonial_container {
    padding: 0px 10px;
  }
}

@media screen and (max-width: 376px) {
  .testimonial_container {
    padding: 0px 10px;
  }
  .left_back_mock {
    left: 10px;
  }
  .right_back_mock {
    right: 10px;
  }
  .header_button {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,+DAAsE;AACxE;;AAEA;EACE,gCAAgC;EAChC,+DAAuE;AACzE;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,+DAAyE;AAC3E;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,+DAAqE;AACvE;;AAEA;EACE,+BAA+B;EAC/B,+DAAsE;AACxE;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,+DAAwE;AAC1E;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,+DAAoE;AACtE;;AAEA;EACE,gCAAgC;EAChC,+DAAuE;AACzE;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,+DAAyE;AAC3E;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,+DAAqE;AACvE;;AAEA,2BAA2B;;AAE3B;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;;;;;;;GAOG;;AAEH;;;;;;;GAOG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;;AAE3B;EACE,2DAA2D;EAC3D,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,2DAA2D;EAC3D,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,yBAAyB;;AAEzB;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;uCACqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;;AAE5B;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Static font imports start*/\r\n@font-face {\r\n  font-family: \"PP Fragment\";\r\n  font-weight: normal;\r\n  src: url(./assets/fonts/PPFragment-TextRegular.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Glare\";\r\n  src: url(./assets/fonts/PPFragment-GlareRegular.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Glare\";\r\n  font-weight: bold;\r\n  src: url(./assets/fonts/PPFragment-GlareExtraBold.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Glare\";\r\n  font-weight: lighter;\r\n  src: url(./assets/fonts/PPFragment-GlareLight.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Sans\";\r\n  src: url(./assets/fonts/PPFragment-SansRegular.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Sans\";\r\n  font-weight: bold;\r\n  src: url(./assets/fonts/PPFragment-SansExtraBold.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Sans\";\r\n  font-weight: lighter;\r\n  src: url(./assets/fonts/PPFragment-SansLight.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Serif\";\r\n  src: url(./assets/fonts/PPFragment-SerifRegular.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Serif\";\r\n  font-weight: bold;\r\n  font-style: normal;\r\n  src: url(./assets/fonts/PPFragment-SerifExtraBold.otf) format(\"opentype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: \"PP Fragment-Serif\";\r\n  font-weight: 0 300;\r\n  font-style: lighter;\r\n  src: url(./assets/fonts/PPFragment-SerifLight.otf) format(\"opentype\");\r\n}\r\n\r\n/* Static font imports end*/\r\n\r\nhtml {\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  width: 100%;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  min-height: 100vh;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Make autofill in input of background white */\r\n/* input:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ninput:-webkit-autofill:active {\r\n    transition: background-color 5000s ease-in-out 0s;\r\n    -webkit-text-fill-color: black;\r\n    color: black;\r\n} */\r\n\r\n/* .top-container-lg input:-webkit-autofill,\r\n.top-container-lg input:-webkit-autofill:hover,\r\n.top-container-lg input:-webkit-autofill:focus,\r\n.top-container-lg input:-webkit-autofill:active {\r\n    transition: background-color 5000s ease-in-out 0s;\r\n    -webkit-text-fill-color: black;\r\n    color: black;\r\n} */\r\n\r\n.padding_all {\r\n  padding: 20px 50px;\r\n}\r\n\r\n.max-width1400 {\r\n  max-width: 1800px !important;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.ReactCollapse--collapse {\r\n  transition: height 200ms;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n}\r\n\r\n.mySwiper {\r\n  width: 100%;\r\n}\r\n.mySwiper-investors {\r\n  width: 100%;\r\n  height: 720px;\r\n  display: flex;\r\n}\r\n\r\n.swiper-slide {\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\n.swiper-slide-investors {\r\n  width: 400px;\r\n  border-radius: 16px;\r\n  height: fit-content;\r\n}\r\n\r\n.swiper-pagination-bullet-active {\r\n  background: #fff !important;\r\n}\r\n\r\n/* Slick slider css start */\r\n\r\n.slick-next:before {\r\n  /* important used to overide the slick slider default css */\r\n  font-size: 28px !important;\r\n  /* color: #58f2f0 !important; */\r\n}\r\n\r\n.slick-prev:before {\r\n  /* important used to overide the slick slider default css */\r\n  font-size: 28px !important;\r\n  /* color: #58f2f0 !important; */\r\n}\r\n\r\n/* Slick slider css end */\r\n\r\n.inputRounded .MuiOutlinedInput-root {\r\n  border-radius: 30px;\r\n  height: 48px;\r\n  padding-right: 6px !important;\r\n  /* border: 2px solid #58f2ef8f !important; */\r\n}\r\n\r\n.inputRounded {\r\n  height: 48px;\r\n  margin-bottom: 2vh;\r\n  border-radius: 30px;\r\n  margin-top: 10px;\r\n  width: 100%;\r\n}\r\n\r\n/* .top-container-lg .inputRounded {\r\n    border: 1px solid #58f2ef8f !important;\r\n}\r\n\r\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\r\n    border: 1px solid #6976b4;\r\n} */\r\n\r\n.MuiTabs-indicator {\r\n  background-color: #046149 !important;\r\n}\r\n\r\n.layout_body {\r\n  min-height: 100vh;\r\n  padding-top: 70px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selected-link {\r\n  /* color: #58f2f0 !important;\r\n    border-bottom: 2px solid #58f2f0; */\r\n  padding-bottom: 11px !important;\r\n}\r\n\r\n.hiw-slider .slick-initialized .slick-slide {\r\n  width: auto !important;\r\n}\r\n\r\n.lazy-load-image-background.blur.lazy-load-image-loaded {\r\n  height: 100%;\r\n}\r\n\r\n.MuiMenuItem-root {\r\n  min-height: 20px !important;\r\n}\r\n\r\n.small_screen {\r\n  display: none;\r\n}\r\n\r\n.header_variant {\r\n  /* background: #2D355A; */\r\n  position: sticky;\r\n}\r\n\r\n.market_header {\r\n  /* background: transparent; */\r\n  position: sticky;\r\n}\r\n\r\n.header_padding {\r\n  padding-top: 80px;\r\n}\r\n\r\n.hiw-slider .slick-list {\r\n  padding: 0 0 0 3% !important;\r\n}\r\n\r\n.show-mobile {\r\n  display: block !important;\r\n}\r\n\r\n/* Responsivness css start */\r\n\r\n@media screen and (min-device-width: 1200px) and (max-device-width: 1400px) {\r\n  .inputRounded {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .inputRounded {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 570px) {\r\n  .padding_all {\r\n    padding: 0px 20px;\r\n  }\r\n  .no-padding-left {\r\n    padding-left: 0 !important;\r\n  }\r\n  .small_screen {\r\n    display: block !important;\r\n  }\r\n  .large_screen {\r\n    display: none;\r\n  }\r\n  .inputRounded .MuiOutlinedInput-root {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 426px) {\r\n  .text-wrap-div-2 {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: no-wrap;\r\n  }\r\n  .text-wrap-div {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: no-wrap;\r\n  }\r\n  .large_screen {\r\n    display: none;\r\n  }\r\n  .small_screen {\r\n    display: block !important;\r\n  }\r\n  .testimonial_container {\r\n    padding: 0px 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 376px) {\r\n  .testimonial_container {\r\n    padding: 0px 10px;\r\n  }\r\n  .left_back_mock {\r\n    left: 10px;\r\n  }\r\n  .right_back_mock {\r\n    right: 10px;\r\n  }\r\n  .header_button {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
